import { ISupportInfo } from "@/api/support/interface";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ContactInfoFormatter extends Vue {

	@Prop(Object)
	readonly contact?: ISupportInfo

	get telegramFormatted(): string {
		return '@' + (this.telegramLink?.split('/')?.pop() || '');
	}

	get telegramLink(): string {
		return this.contact?.telegram || "https://t.me/corpinfbsupportbot";
	}

	get phoneInitial(): string {
		return this.contact?.phone || "+998712025080";
	}

	get phoneFormatted(): string {
		return `+${this.phoneInitial.slice(1, 4)} (${this.phoneInitial.slice(4, 6)}) ` +
			`${this.phoneInitial.slice(6, 9)}-${this.phoneInitial.slice(9, 11)}-` +
			this.phoneInitial.slice(11);
	}

	get phoneLink(): string {
		return 'tel:' + this.phoneInitial;
	}

}